import React from "react";
import { CalendarDays, CheckCircle2, ClipboardEdit, PlayCircle } from "lucide-react";
import { actionLabel, formatDate, statusTone, stepLabels } from "./performanceUi";

export default function PerformanceCampaignCard({ campaign, loading, onOpen, onPlanifier, onReviser }) {
    const progressId = campaign.evaluationProgressId;
    const label = actionLabel(campaign.primaryAction, Boolean(progressId), campaign.progressStatus, campaign.progressionPourcentage);
    const tone = statusTone(campaign.progressStatus || campaign.statutCampagne);
    const currentStepLabel = campaign.currentStep ? stepLabels[campaign.currentStep] || campaign.currentStep : "Non demarree";

    return (
        <article className="perf-campaign-card">
            <div className="perf-campaign-card__top">
                <div>
                    <h2>{campaign.nom || "Campagne performance"}</h2>
                    <p>{campaign.reference || "Sans reference"}</p>
                </div>
                <span className={`perf-badge perf-badge--${tone}`}>
                    {campaign.progressStatus || campaign.statutCampagne || "ACTIVE"}
                </span>
            </div>

            <div className="perf-campaign-card__meta">
                <span><CalendarDays size={14} />{formatDate(campaign.dateDebut)} - {formatDate(campaign.dateFin)}</span>
                <span><CheckCircle2 size={14} />Etape courante : {currentStepLabel}</span>
            </div>

            <div className="perf-campaign-card__progress">
                <div>
                    <strong>{campaign.progressionPourcentage ?? 0}%</strong>
                </div>
                <div className="perf-progressbar" aria-hidden="true">
                    <span style={{ width: `${Math.min(Number(campaign.progressionPourcentage || 0), 100)}%` }} />
                </div>
            </div>

            <div className="perf-campaign-card__actions">
                <button className="perf-btn perf-btn--primary" type="button" disabled={loading} onClick={() => onOpen(campaign)}>
                    <PlayCircle size={15} />
                    {loading ? "Ouverture..." : label}
                </button>
                <button className="perf-btn" type="button" disabled={loading || !onReviser || campaign.progressStatus === "PENDING_VALIDATION" || campaign.progressStatus === "COMPLETED"} onClick={() => onReviser?.(campaign)}>
                    <ClipboardEdit size={15} />
                    Réviser
                </button>
                <button className="perf-btn" type="button" disabled={loading} onClick={() => onPlanifier(campaign)}>
                    <CalendarDays size={15} />
                    Planifier
                </button>
            </div>
        </article>
    );
}
